module.exports = __webpack_public_path__ + "img/crop-alt-solid.480f8ae6.svg";